module.exports = __webpack_public_path__ + "static/media/brainflix-iphonex-hero-one.2f2585bd.jpg";